import React, { useEffect, useState } from "react";
import DashboardTitleComponent from "../../../../components/layout/Dashboard/Title/DashboardTitleComponent";
import BoxComponent from "../../../../components/Box/BoxComponent";
import { styleSections } from "../styles";
import TypographyComponent from "../../../../components/Typography/ThypographyComponent";
import ButtonComponent from "../../../../components/Button/ButtonComponent";
import { ReactComponent as PlusIcon } from "../../../../assets/icons/plus.svg";
import { ReactComponent as DownloadIcon } from "../../../../assets/icons/download.svg";
import SearchIcon from "../../../../assets/icons/search_icon.png";
import SvgComponent from "../../../../components/Image/SvgComponent";
import ImageLogoComponent from "../../../../components/Image/ImageLogoComponent";
import TextFieldComponent from "../../../../components/TextField/TextFieldComponent";
import { CatalogoComplementoEspecifico, CatalogoItemComplemento, ItemDestaque } from "../../public/CatalogoPage";
import CatalogoAdminItemCard from "./card/CatalogoAdminItemCard";
import ModalCategoria from "./modal/ModalCategoria";
import { CatalogoCategoria, ItemCategoria } from "../../../../interface/item/categoria/ItemCategoria";
import { catalogoService } from "../../../../service/CatalogoService";
import ModalItemCatalogo from "./modal/ModalItemCatalogo";
import { formatDinheiroToNumber } from "../../../../utils/dinheiro";
import { formatNumberToPtBr } from "../../../../utils/numero";

interface CatalogoAdminPrincipalProps {
    categoriaSelecionada: ItemCategoria | undefined;
    itensCategoria: ItemDestaque[];
    idEmpresa: number | undefined;
    token: string | null;
    updateCategorias: () => void;
    updateItens: () => void;
}

export interface CatalogoRequestDTO {
    id?: number;
    idCategoria?: number | undefined;
    idEmpresa?: number | undefined;

    titulo: string;
    descricao: string;

    //ativo: boolean;
    promocao: boolean;
    delivery: boolean;
    mesa: boolean;
    balcao: boolean;

    custoAutomatico: boolean;

    precoVenda?: number;
    precoVendaStr?: string;

    precoCusto?: number;
    precoCustoStr?: string;

    disponibilidade: CatalogoDisponibilidadeDTO[];
    // itens: CatalogoItemDTO[];
    // adicionais?: CatalogoValorAdicionalDTO[];
    complementos: CatalogoItemComplemento[],
    complementosEspecificos: CatalogoComplementoEspecifico[],

    midias: CatalogoMidiaDTO[];

    pdv: string;
    etiqueta: string;
}

export enum DiaSemana {
    SEGUNDA = "SEGUNDA",
    TERCA = "TERCA",
    QUARTA = "QUARTA",
    QUINTA = "QUINTA",
    SEXTA = "SEXTA",
    SABADO = "SABADO",
    DOMINGO = "DOMINGO"
}

export interface CatalogoDisponibilidadeDTO {
    id?: number;
    diaSemana: DiaSemana;
    ativo: boolean;

    /**
     * Formato: HH:mm
     * Ex.: "08:00"
     */
    hrInicial: string;

    /**
     * Formato: HH:mm
     * Ex.: "18:00"
     */
    hrFinal: string;
}

export interface CatalogoItemDTO {
    idItem: number;

    /**
     * BigDecimal
     */
    qtd: number;

    /**
     * BigDecimal
     */
    vlrUnitario: number;
}

export interface CatalogoValorAdicionalDTO {
    nome: string;

    /**
     * BigDecimal
     */
    valor?: number;

    /**
     * BigDecimal
     */
    percentual?: number;
}

export interface CatalogoMidiaDTO {
    id?: number;          // já existe quando veio do backend
    nome?: string;
    //url?: string;         // imagem já salva
    //file?: File;          // imagem nova
    preview?: string;     // apenas frontend
    principal?: boolean;
    ordem?: number;

    /**
     * Arquivo enviado pelo usuário.
     * Quando o objeto vier da API esse campo normalmente será undefined.
     */
    arquivo?: File;

    ativo: boolean;

    /**
     * Base64 ou URL da imagem retornada pelo backend.
     */
    caminho?: string;
}

const CatalogoAdminPrincipal = (props: CatalogoAdminPrincipalProps) => {
    const [produto, setProduto] = useState<string>("");

    const styleButtonHeader = {
        fontFamily: '"Font 7", sans-serif',
        fontWeight: 500,
        fontSize: '16px',
        lineHeight: '24px',
        letterSpacing: '0%',
        textAlign: 'center',
        color: "#FFFFFF",
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        verticalAlign: 'middle',
        textTransform: 'none',
        gap: 1.5
    }

    /* MODAL DE CATEGORIAS */
    const [modalCategoria, setModalCategoria] = useState({
        open: false,
        tab: 0
    });

    const handleOpenModalCategoria = () => {
        setModalCategoria({
            ...modalCategoria,
            open: true,
            tab: 0
        })
    }

    const handleCloseModalCategoria = () => {
        setModalCategoria({
            ...modalCategoria,
            open: false,
            tab: 0
        })
    }

    const handleChangeTabModalCategoria = (tab: number) => {
        setModalCategoria({
            ...modalCategoria,
            tab: tab
        })
    }

    const handleSubmitCategoria = async (categoria: CatalogoCategoria) => {
        if (!props.token || !props.idEmpresa) return;

        const formData = new FormData();

        formData.append("nome", categoria.nome);
        formData.append("descricao", categoria.descricao);
        formData.append("ativo", categoria.ativo.toString());

        var sucesso = await catalogoService.registerCategoria(
            formData,
            props.idEmpresa,
            props.token
        )

        if (sucesso) {
            await props.updateCategorias();
            handleCloseModalCategoria();
        }
    }

    /* MODAL DE NOVO ITEM */
    const [modalItemCatalogo, setModalItemCatalogo] = useState({
        open: false,
        tab: 0
    });

    const handleOpenModalItem = () => {
        setModalItemCatalogo({
            ...modalItemCatalogo,
            open: true,
            tab: 0
        });
    }

    const handleCloseModalItem = () => {
        setModalItemCatalogo({
            ...modalItemCatalogo,
            open: false,
            tab: 0
        });
        handleClearItemCatalogo();
    }

    const handleChangeTabModalItem = (tab: number) => {
        setModalItemCatalogo({
            ...modalItemCatalogo,
            tab: tab
        })
    }

    // ITEM DO CATALOGO, PARA EDICAO/EXCLUSAO
    const [itemCatalogo, setItemCatalogo] = useState<CatalogoRequestDTO>();

    const handleClearItemCatalogo = () => {
        setItemCatalogo({
            id: undefined,
            titulo: "",
            descricao: "",
            promocao: false,
            custoAutomatico: false,
            precoVenda: undefined,
            precoVendaStr: "",
            precoCusto: undefined,
            precoCustoStr: "",
            delivery: true,
            mesa: true,
            balcao: true,
            midias: [],
            pdv: "",
            etiqueta: "",
            disponibilidade: [],
            complementos: [],
            complementosEspecificos: []
        })
    }

    const handleClickEditCatalogo = (item: ItemDestaque) => {
        /* SET DE ITEM */
        setItemCatalogo({
            id: item.id,
            titulo: item.titulo,
            descricao: item.descricao,
            promocao: item.promocao,
            delivery: item.delivery,
            mesa: item.mesa,
            balcao: item.balcao,
            custoAutomatico: item.custoAutomatico,

            midias: item.midias ? item.midias.map((midia) => ({
                id: midia.id,
                nome: midia.nome,
                ativo: midia.ativo,
                caminho: midia.caminho,
                preview: midia.caminho,
                principal: false,
                ordem: 0
            })) : [],

            precoVenda: item.precoVenda,
            precoVendaStr: item.precoVenda ? formatNumberToPtBr(item.precoVenda) : "",
            precoCusto: item.precoCusto,
            precoCustoStr: item.precoCusto ? formatNumberToPtBr(item.precoCusto) : "",

            disponibilidade: item.disponibilidade,
            complementos: item.complementos ? item.complementos.map((element) => ({
                id: element.id,
                nome: element.nome,
                vlrUnitario: element.vlrUnitario,
                vlrUnitarioStr: element.vlrUnitarioStr,
                ativo: element.ativo,
                selecionado: element.selecionado
            })) : [],
            complementosEspecificos: item.complementosEspecificos,

            pdv: item.pdv,
            etiqueta: item.etiqueta
        });
        handleOpenModalItem();
    }

    const handleClickDeleteCatalogo = async (item: ItemDestaque) => {        
        alert(`Deletando item #${item.id}`);

        if (!props.token) return;
        else if (!props.categoriaSelecionada) return;
        else if (!props.idEmpresa) return;

        const response = await catalogoService.deleteCatalogo(props.idEmpresa, item.id, props.token);
        if (response) {
            alert("Item do catálogo deletado.");
            handleCloseModalItem();
            await props.updateCategorias();
            await props.updateItens();
        }
    }

    // SUBMIT
    const handleSubmit = async (data: CatalogoRequestDTO) => {
        if (!props.token) return;
        else if (!props.categoriaSelecionada) return;
        else if (!props.idEmpresa) return;

        const isCatalogoLancado = data.id !== undefined && data.id !== null;

        const formData = new FormData();

        formData.append("idEmpresa", props.idEmpresa.toString());
        formData.append("idCategoria", props.categoriaSelecionada.id!.toString());

        formData.append("titulo", data.titulo);
        formData.append("descricao", data.descricao);
        formData.append("promocao", String(data.promocao));
        formData.append("custoAutomatico", String(data.custoAutomatico));

        if ("precoVendaStr" in data) {
            formData.append(
                "precoVenda",
                String(formatDinheiroToNumber(data.precoVendaStr || ""))
            );
        }

        if ("precoCustoStr" in data) {
            formData.append(
                "precoCusto",
                String(formatDinheiroToNumber(data.precoCustoStr || ""))
            );
        }

        formData.append("delivery", String(data.delivery));
        formData.append("mesa", String(data.mesa));
        formData.append("balcao", String(data.balcao));
        formData.append("pdv", data.pdv);
        formData.append("etiqueta", data.etiqueta);

        const disponibilidade = data.disponibilidade.filter((element) => element.diaSemana && element.ativo && element.hrInicial !== "" && element.hrFinal !== "");

        // Objetos e listas
        for (let i = 0; i < disponibilidade.length; i++) {
            const disponibilidade = data.disponibilidade[i];

            if (disponibilidade.id) formData.append(`disponibilidade[${i}].id`, String(disponibilidade.id));            
            formData.append(`disponibilidade[${i}].diaSemana`, String(disponibilidade.diaSemana));
            formData.append(`disponibilidade[${i}].ativo`, String(disponibilidade.ativo));
            formData.append(`disponibilidade[${i}].horaInicial`, String(disponibilidade.hrInicial));
            formData.append(`disponibilidade[${i}].horaFinal`, String(disponibilidade.hrFinal));
        }

        // MIDIA
        const midiasNovas = data.midias.filter((element) => element.id === null || element.id === undefined);
        formData.append(
            "request",
            new Blob([JSON.stringify(midiasNovas)], {
                type: "application/json"
            })
        );

        midiasNovas.forEach((m, index) => {
            formData.append(`midias[${index}].arquivo`, m.arquivo!);
            formData.append(`midias[${index}].nome`, String(m.nome));
        });

        // COMPLEMENTOS
        for (let i = 0; i < data.complementos.length; i++) {
            const complemento = data.complementos[i];

            formData.append(`complementos[${i}].id`, String(complemento.id));
            formData.append(`complementos[${i}].nome`, String(complemento.nome));
            formData.append(`complementos[${i}].ativo`, String(complemento.ativo));
            formData.append(`complementos[${i}].selecionado`, String(complemento.selecionado));
            //formData.append(`complementos[${i}].vlrUnitario`, String(formatDinheiroToNumber(complemento.vlrUnitarioStr ?? "")));
        }

        for (let i = 0; i < data.complementosEspecificos.length; i++) {
            const complementoEspecifico = data.complementosEspecificos[i];

            if (complementoEspecifico.id) formData.append(`complementosEspecificos[${i}].id`, String(complementoEspecifico.id));
            formData.append(`complementosEspecificos[${i}].nome`, String(complementoEspecifico.nome));
            formData.append(`complementosEspecificos[${i}].vlrUnitario`, String(formatDinheiroToNumber(complementoEspecifico.vlrUnitarioStr ?? "")));
            formData.append(`complementosEspecificos[${i}].ativo`, String(complementoEspecifico.ativo));
        }

        var response;

        if (isCatalogoLancado && data.id) response = await catalogoService.patchCatalogo(data.id, formData, props.token);
        else response = await catalogoService.registerCatalogo(formData, props.token);

        if (response) {            
            alert(isCatalogoLancado ? "Catálogo editado" : "Criado um novo produto!");
            handleCloseModalItem();
            await props.updateCategorias();
            await props.updateItens();
        }
    }

    /* HEADER */

    const renderHeader = () => {
        const handleClickNovaCategoria = () => {
            handleOpenModalCategoria();
        }

        const handleClickImportarCatalogo = () => {
            alert("cliquei para importar catalogo");
        }

        const handleClickNovoItem = () => {
            handleOpenModalItem();
        }

        const handleChangeInputProduto = (value: string) => {
            setProduto(value);
        }

        return <>
            <BoxComponent component="div" sx={{
                ...styleSections,
                p: 2,
                height: "auto",
                gap: 1.2
                // flexDirection: "row",
                // justifyContent: "space-between"
            }}>
                {/* HEADER PRINCIPAL */}
                <BoxComponent component="div"
                    sx={{
                        display: "flex", alignItems: "center", justifyContent: "space-between"
                    }}
                >
                    <BoxComponent component="div" sx={{
                        display: "flex", flexDirection: "column"
                    }}>
                        <TypographyComponent variant="h1"
                            sx={{
                                fontFamily: '"Font 7", sans-serif',
                                fontWeight: 700,
                                fontSize: '30px',
                                lineHeight: '36px',
                                letterSpacing: '0%',
                                color: '#2C2C2C',
                                display: 'inline-flex',
                                alignItems: 'center',
                                verticalAlign: 'middle'
                            }}
                        >
                            Catálogo
                        </TypographyComponent>
                        {/* <TypographyComponent variant="body2"
                            sx={{
                                fontFamily: '"Font 7", sans-serif',
                                fontWeight: 400,
                                fontSize: '16px',
                                lineHeight: '24px',
                                letterSpacing: '0%',
                                color: '#666666',
                                display: 'inline-flex',
                                alignItems: 'center',
                                verticalAlign: 'middle'
                            }}
                        >
                            a
                        </TypographyComponent> */}
                    </BoxComponent>
                    <BoxComponent component="div" sx={{
                        display: "flex",
                        gap: 2
                    }}>
                        <ButtonComponent id="nova_categoria"
                            variant="outlined"
                            sx={{
                                ...styleButtonHeader,
                                backgroundColor: "#10B981"
                            }}
                            onClick={handleClickNovaCategoria}
                        >
                            <SvgComponent
                                icon={<PlusIcon />}
                                sx={{
                                    display: "flex",
                                    alignpropss: "center",
                                    justifyContent: "center",
                                    width: 18,
                                    height: 18,
                                    "& svg, & svg *": {
                                        stroke: "#FFFFFF",
                                    },
                                }}
                            />
                            Nova categoria
                        </ButtonComponent>
                        <ButtonComponent id="importar_catalogo"
                            disabled
                            sx={{
                                ...styleButtonHeader,
                                backgroundColor: "#3B82F6"
                            }}
                            onClick={handleClickImportarCatalogo}
                        >
                            <SvgComponent
                                icon={<DownloadIcon />}
                                sx={{
                                    display: "flex",
                                    alignpropss: "center",
                                    justifyContent: "center",
                                    width: 18,
                                    height: 18,
                                    "& svg, & svg *": {
                                        stroke: "#BBB",
                                        fill: "transparent"
                                    },
                                }}
                            />
                            Importar cardápio
                        </ButtonComponent>
                        <ButtonComponent id="novo_pedido"
                            sx={{
                                ...styleButtonHeader,
                                backgroundColor: "#FF8C42"
                            }}
                            onClick={handleClickNovoItem}
                            disabled={props.categoriaSelecionada === undefined}
                        >
                            <SvgComponent
                                icon={<PlusIcon />}
                                sx={{
                                    display: "flex",
                                    alignpropss: "center",
                                    justifyContent: "center",
                                    width: 18,
                                    height: 18,
                                    "& svg, & svg *": {
                                        stroke: "#FFFFFF",
                                    },
                                }}
                            />
                            Novo item
                        </ButtonComponent>
                    </BoxComponent>
                </BoxComponent>

                {props.itensCategoria.length !== 0 && (
                    <BoxComponent
                        component="div"
                        sx={{
                            display: "flex",
                            alignContent: "center",
                            alignItems: "center",
                            justifyContent: "flex-start",
                            border: "1px solid #E8DFD5",
                            borderRadius: "10px",
                            height: "41px",
                            width: "100%",
                            gap: 2
                        }}
                    >
                        <ImageLogoComponent
                            sx={{
                                margin: 1.85,
                                width: 20,
                                height: 20
                            }}
                            src={SearchIcon}
                            alt="icone_pesquisa_produto"
                        />
                        <TextFieldComponent
                            id="busca_produto"
                            placeholder="Pesquisar produtos..."
                            variant="standard"
                            disableUnderline
                            fullWidth
                            value={produto}
                            onInput={(e) => {
                                const target = e.target as HTMLInputElement;
                                if (target) handleChangeInputProduto(target.value)
                            }}
                        />
                    </BoxComponent>
                )}
            </BoxComponent>
        </>
    }

    const renderItens = () => {
        if (props.itensCategoria === null || props.itensCategoria === undefined || props.itensCategoria.length === 0) return <></>;

        return <BoxComponent component="div" sx={{
            ...styleSections,
            p: 2,
        }}>
            <BoxComponent component="div"
                sx={{
                    display: "flex",
                    flexWrap: "wrap",
                    gap: 2,
                }}
            >
                {props.itensCategoria.map((item: ItemDestaque, index: number) => {
                    return <CatalogoAdminItemCard
                        key={`item-${index}`}
                        item={item}
                        onClickEdit={handleClickEditCatalogo}
                        onClickDelete={handleClickDeleteCatalogo}
                    />
                })}
            </BoxComponent>
        </BoxComponent>
    }

    return <>
        <ModalCategoria
            open={modalCategoria.open}
            onClose={handleCloseModalCategoria}
            tab={modalCategoria.tab}
            onChangeTab={handleChangeTabModalCategoria}
            onSubmit={handleSubmitCategoria}
        />

        <ModalItemCatalogo
            open={modalItemCatalogo.open}
            onClose={handleCloseModalItem}
            tab={modalItemCatalogo.tab}
            onChangeTab={handleChangeTabModalItem}

            idEmpresa={props.idEmpresa}
            token={props.token}

            itemCatalogo={itemCatalogo}

            categoriaSelecionada={props.categoriaSelecionada}

            onSubmit={handleSubmit}
        />

        {renderHeader()}
        {renderItens()}
    </>;
}

export default CatalogoAdminPrincipal;